import commonOps from './options';
export default {
  // 证件类型渲染函数
  idTypeRender: (text, options) => {
    const ops = options || commonOps.idTypeOps;
    let selected = {};
    if (ops && ops.length > 0) {
      selected = ops.find(item => {
        return item.code == text;
      });
    }
    return selected && selected.name ? selected.name : '';
  },
  // 性别渲染函数
  genderRender(text) {
    return text === 'M' || text === '男' ? '男' : '女';
  },
  // 被保人保费渲染函数
  premiumRender(text, record) {
    return record.newPremium ? record.newPremium : text;
  },
  // 校验身份证号码是否正确
  checkIdNumber(val, idType) {
    const reg = /^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$)$/;
    let flag = true;
    if (val && idType == '1') {
      flag = reg.test(val);
      if (!flag) {
        window.message.error('证件号码不正确');
      }
    }
    return flag;
  },
  // 校验邮箱是否符合规范
  checkEmail(val, name) {
    const reg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    let flag = true;
    if (val) {
      flag = reg.test(val);
      if (!flag) {
        window.message.error(`${name}不正确`);
      }
    }
    return flag;
  },
  // 校验手机号是否符合规范
  checkPhone(val, name) {
    const reg = /^((0\d{2,3}-?\d{7,8})|(1[3465789]\d{9}))$/;
    let flag = true;
    if (val) {
      flag = reg.test(val);
      if (!flag) {
        window.message.error(`${name}不正确`);
      }
    }
    return flag;
  },
  // 根据身份证号码自动带出生日和性别
  calcBGByIdCardNumber(idNumber) {
    const year = idNumber.slice(6, 10);
    const mon = idNumber.slice(10, 12);
    const day = idNumber.slice(12, 14);
    const birthDate = year + '-' + mon + '-' + day;
    const gender = idNumber.slice(16, 17) % 2 == 1 ? 'M' : 'F';
    return {
      birthDate,
      gender
    };
  },
  // 根据国籍code获取国籍名称
  countryName(val) {
    const ops = commonOps.countryOps;
    const countryName = ops.find(item => {
      return item.code === val;
    }).name;
    return countryName;
  },
  // 判断是否微信
  isWeiXin() {
    return /micromessenger/i.test(navigator.userAgent.toLowerCase()) || typeof navigator.wxuserAgent !== 'undefined';
  },
  // 关闭浏览器
  closeWindow(context) {
    // 如果是微信内打开
    if (this.isWeiXin()) {
      document.addEventListener('WeixinJSBridgeReady', function() {
        WeixinJSBridge.call('closeWindow');
      });
      WeixinJSBridge.call('closeWindow');
      return;
    }
    const opener = window.opener && window.opener !== window;
    // 如果opener存在
    if (opener) {
      window.close();
    } else {
      context.$router.go(-1);
    }
  }
};
